
import React from 'react';
import { Load } from './types';
import { floorPlans } from './data/zoneData';
import FloorTitle from './map-components/FloorTitle';
import ZoneGrid from './map-components/ZoneGrid';

interface LoadFloorMapProps {
  loads: Load[];
  selectedFloor: number;
  selectedZone: string | null;
  onZoneSelect: (zoneId: string) => void;
  handleToggleStatus: (id: string) => void;
  openScheduling: (load: Load) => void;
}

const LoadFloorMap: React.FC<LoadFloorMapProps> = ({ 
  loads, 
  selectedFloor, 
  selectedZone, 
  onZoneSelect,
  handleToggleStatus,
  openScheduling
}) => {
  const zones = floorPlans[selectedFloor] || [];
  
  return (
    <div className="mb-8">
      <FloorTitle floorNumber={selectedFloor} />
      
      <ZoneGrid 
        zones={zones}
        loads={loads}
        selectedZone={selectedZone}
        onZoneSelect={onZoneSelect}
        handleToggleStatus={handleToggleStatus}
        openScheduling={openScheduling}
      />
    </div>
  );
};

export default LoadFloorMap;
